import { useEffect, useState } from 'react';
import './App.css';
import Die from './components/Die';
import Confetti from 'react-confetti';

function App() {
  const [dice, setDice] = useState(allNewDice());
  const [tenzies, setTenzies] = useState(false);
  const [attempts, setAttempts] = useState(1);
  const [best, setBest] = useState(undefined);

  function allNewDice() {
    let newDice = [];
    for (let i=0; i< 10; i++){
      newDice.push({
        id: i,
        value: Math.ceil(Math.random() * 6),
        isHeld: false
      })
    }

    return newDice;
  }

  function rollDice() {
    if (!tenzies) {
      setDice(oldDice => oldDice.map(die => {
        return die.isHeld 
          ? die
          : {...die, value: Math.ceil(Math.random() * 6)}
      }))
      setAttempts(prevAttempts => prevAttempts + 1);
    } else {
      setDice(allNewDice());
      setTenzies(false);
      if (!best || attempts < best) {
        setBest(attempts);
      }
      setAttempts(1);
    }
  }

  function holdDice(event, id){
    setDice(prevDice => {
      let newDice = [];
      prevDice.forEach(die => {
        if (die.id === id) {
          newDice.push({...die, isHeld: !die.isHeld})
        } else {
          newDice.push(die)
        }        
      });
      return newDice;
    })
  }

  useEffect(() => {
    let sameNumber = dice[0].value;
    if (dice.every(die => die.isHeld === true && die.value === sameNumber)){
      setTenzies(true);
    }
  }, [dice])

  return (
    <main>
      {tenzies && <Confetti />}
      <h1 className="title">Tenzies</h1>
      <p className="instructions">Roll until all dice are the same. Click each die to freeze it at its current value between rolls.</p>
      <div className="dice">
        {dice.map(die => {
          return <Die 
            key={die.id} 
            id={die.id}
            value={die.value} 
            isHeld={die.isHeld}
            holdDice={holdDice}
          />
        })}
      </div>
      <button 
        className="roll-button"
        onClick={rollDice}>
          {tenzies ? "New Game" : "Roll" }
      </button>
      <h2>Atttempts: {attempts} {best && `-- Best: ${best}`}</h2>
    </main>
  );
}

export default App;
